import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  white-space: pre-wrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  margin-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { Button, IconButton } from '@scp/ui-shared/components/buttons';
import { Icon } from '@scp/ui-shared/theme/icons';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { TextArea } from '@scp/ui-shared/components/form-fields/TextArea';
import { Spacing } from '@scp/ui-shared/components/layout';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var TEXT = {
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  SAVE: 'Save',
  EDIT: 'Edit text'
};
var E2E = {
  VALUE_SUFFIX: '-value',
  EDIT_SUFFIX: '-edit',
  DELETE_SUFFIX: '-delete',
  CANCEL_SUFFIX: '-cancel',
  SAVE_SUFFIX: '-save'
};
var Wrapper = styled.div(_templateObject(), baselineToRem(4));
var Actions = styled.div(_templateObject2(), baselineToRem(2));
var PreviewWrapper = styled.div(_templateObject3());
var PreviewValue = styled(Paragraph).attrs({
  noMargin: true
})(_templateObject4(), baselineToRem(4));
var EditButton = styled(IconButton)(_templateObject5());
export var InlineTextArea = function InlineTextArea(_a) {
  var id = _a.id,
      _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$emptyState = _a.emptyState,
      emptyState = _a$emptyState === void 0 ? 'Click pen to edit' : _a$emptyState,
      _a$placeholder = _a.placeholder,
      placeholder = _a$placeholder === void 0 ? 'Enter the text' : _a$placeholder,
      disabled = _a.disabled,
      _a$hiddenLabel = _a.hiddenLabel,
      hiddenLabel = _a$hiddenLabel === void 0 ? true : _a$hiddenLabel,
      _a$hideError = _a.hideError,
      hideError = _a$hideError === void 0 ? true : _a$hideError,
      onCancel = _a.onCancel,
      onDelete = _a.onDelete,
      onSave = _a.onSave,
      onEditToggle = _a.onEditToggle,
      saveLabel = _a.saveLabel,
      triggerRenderer = _a.triggerRenderer,
      otherProps = __rest(_a, ["id", "value", "emptyState", "placeholder", "disabled", "hiddenLabel", "hideError", "onCancel", "onDelete", "onSave", "onEditToggle", "saveLabel", "triggerRenderer"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      areaValue = _useState4[0],
      setAreaValue = _useState4[1];

  var areaRef = useCallback(function (inputElement) {
    if (inputElement) {
      inputElement.focus();
    }
  }, []);
  var trimmedValue = areaValue.trim();

  var toggleEditOn = function toggleEditOn() {
    setEditMode(true);
    setAreaValue(value);
    onEditToggle && onEditToggle(true);
  };

  var toggleEditOff = function toggleEditOff() {
    setEditMode(false);
    setAreaValue('');
    onEditToggle && onEditToggle(false);
  };

  var handleSave = function handleSave() {
    if (trimmedValue) {
      onSave(trimmedValue);
      toggleEditOff();
    }
  };

  var handleCancel = function handleCancel() {
    onCancel && onCancel();
    toggleEditOff();
  };

  var handleDelete = function handleDelete() {
    onDelete && onDelete();
    toggleEditOff();
  };

  if (!editMode) {
    if (!!triggerRenderer) {
      return triggerRenderer({
        onToggle: toggleEditOn
      });
    }

    return React.createElement(PreviewWrapper, null, React.createElement(PreviewValue, {
      secondary: !value,
      "data-e2e": getE2eLabel(id, E2E.VALUE_SUFFIX)
    }, value || emptyState), !disabled && React.createElement(EditButton, {
      onClick: toggleEditOn,
      title: TEXT.EDIT,
      dataE2e: getE2eLabel(id, E2E.EDIT_SUFFIX)
    }, React.createElement(Icon, {
      name: "edit"
    })));
  }

  return React.createElement(Wrapper, null, React.createElement(TextArea, Object.assign({
    id: id,
    placeholder: placeholder,
    hiddenLabel: hiddenLabel,
    hideError: hideError,
    value: areaValue,
    innerRef: areaRef,
    onChange: function onChange(e) {
      return setAreaValue(e.target.value);
    }
  }, otherProps)), React.createElement(Actions, null, onDelete && React.createElement(Button, {
    danger: true,
    secondary: true,
    onClick: handleDelete,
    dataE2e: getE2eLabel(id, E2E.DELETE_SUFFIX)
  }, TEXT.DELETE), React.createElement(Spacing, {
    marginLeft: "auto"
  }, React.createElement(Button, {
    secondary: true,
    onClick: handleCancel,
    dataE2e: getE2eLabel(id, E2E.CANCEL_SUFFIX)
  }, TEXT.CANCEL), React.createElement(Button, {
    secondary: true,
    onClick: handleSave,
    disabled: !trimmedValue,
    dataE2e: getE2eLabel(id, E2E.SAVE_SUFFIX)
  }, saveLabel || TEXT.SAVE))));
};